import config from "../../../config";
import "./ImpactChip.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DEFAULT_CLASS = "fvc fc-white impact-chip-default";

export default function ImpactChip({
  potential, // Potential conversions
  current, // Current conversions
  isWCAG = false,
  className = DEFAULT_CLASS,
  tooltipContent = "",
}) {
  let background;
  let text;

  if (isWCAG) {
    background = "var(--dashboard-trend-positive)";
    text = "Accessibility";
  } else {
    const impact = Number(potential) / Number(current);

    if (impact === 0) return null;

    if (impact > config.HIGH_IMPACT) {
      background = "var(--dashboard-trend-negative)";
      text = "High Impact";
    } else if (impact > config.MEDIUM_IMPACT) {
      background = "var(--dashboard-trend-neutral)";
      text = "Medium Impact";
    } else {
      background = "var(--dashboard-trend-positive)";
      text = "Low impact";
    }
  }

  if (!background || !text) return null;

  const content = (
    <div
      className={className}
      style={{
        backgroundColor: background,
      }}
    >
      {text}
    </div>
  );

  if (tooltipContent) {
    return (
      <OverlayTrigger
        placement="top"
        flip={true}
        overlay={
          <Tooltip className="mt-32 mb-32 v4-tooltip topbar-tooltip">
            <div className="fw-700">Impact</div>
            <div className="fw-500 limit-3-lines wrapword lh-192">
              <div>{tooltipContent}</div>
            </div>
          </Tooltip>
        }
      >
        {content}
      </OverlayTrigger>
    );
  }

  return content;
}
